// extracted by mini-css-extract-plugin
export default {"text-m":"Error_text-m__rf3eH","text-s":"Error_text-s__vp9V2","text-xs":"Error_text-xs__tncu9","error":"Error_error__sLNaz","show":"Error_show__YU3Dh"};